import { h } from 'vue';
import { Icon, IconProps } from '@/ui/components/icon/Icon';
import ShieldKeyOutlineIcon from 'vue-material-design-icons/ShieldKeyOutline.vue';

export const defaultIconSize = 18;
export const starsIcon = () => h(Icon, { props: { icon: 'stars', iconPack: 'far' } });

export const featureExplanationIcon = (props: Omit<IconProps, 'icon' | 'iconPack'> = {}) => h(Icon, {
  props: {
    ...props,
    size: props.size ?? 'xs',
    iconPack: 'fal',
    icon: 'info-circle',
    classes: `feature-explanation-icon ${props.classes ?? ''}`,
  },
});

export const ssoIcon = (size = defaultIconSize) => h(ShieldKeyOutlineIcon, {
  props: {
    title: '',
    size,
  },
}, []);

export const ssoHelpCenterIcon = (props: Omit<IconProps, 'icon' | 'iconPack'> = {}) => h(Icon, {
  props: {
    ...props,
    size: props.size ?? 'md',
    iconPack: 'far',
    icon: 'question-circle',
    classes: `sso-help-center-icon ${props.classes ?? ''}`,
  },
});
